<nav class="menu-left"
  [ngClass]="{'whiteLabelNavShared': (isViewingSharedProject() | async) === true, 'whiteLabelNavNotShared': (isViewingSharedProject() | async) === false}">
  <div class="logo" (click)="goHome()">
    @if (!whiteLabel || !whiteLabel.logoUrl) {
      <gl-icon
        [name]="'goodLoadingLogo'"
      ></gl-icon>
    }
    @if (whiteLabel && whiteLabel.logoUrl) {
      <div
        [ngClass]="{'whiteLabelWrapper': (isViewingSharedProject() | async) === true, 'whiteLabelWrapperNotShared': (isViewingSharedProject() | async) === false}">
        <img alt="{{whiteLabel.companyName}}" class="whiteLabelLogo" src="{{ whiteLabel.logoUrl }}" />
      </div>
    }
  </div>
  @if ((isViewingSharedProject() | async) === true  && isSharedMenuOpen) {
    <ul class="shared-menu dropdown-menu right">
      <li (click)="leftMenuClick()">
        <gl-icon [name]="'leftMenu'" class="menuIcon"></gl-icon>
      </li>
      <li (click)="bottomMenuClick()">
        <gl-icon [name]="'bottomMenu'" class="menuIcon"></gl-icon>
      </li>
      <li (click)="downloadPdf(false)">
        <gl-icon [name]="'pdfIco'"></gl-icon>
      </li>
      @if (isMultiSpace) {
        <div class="multiStop">
          <div class="multiStopContainer">
            <div class="leftArrow" (click)="changeStop(currentWorkSpaceIndex, currentStopIndex - 1)">
              <gl-icon [name]="'undo'" class="leftArrowIcon" [ngClass]="{'disabled': currentStopIndex < 1}"></gl-icon>
            </div>
            <div class="stepNameContainer">
              <span class="multiStopLetter">{{ getStopLetterFromIndex(currentStopIndex) }}</span>
              <span class="multiStopName"
              title="{{project.workSpaces[currentWorkSpaceIndex].stops[currentStopIndex].name}}">{{ project.workSpaces[currentWorkSpaceIndex].stops[currentStopIndex].name }}</span>
            </div>
            <div class="rightArrow" (click)="changeStop(currentWorkSpaceIndex, currentStopIndex + 1)">
              <gl-icon [name]="'undo'" class="rightArrowIcon"
              [ngClass]="{'disabled': currentStopIndex >= project.workSpaces[currentWorkSpaceIndex].stops.length - 1}"></gl-icon>
            </div>
          </div>
        </div>
      }
      <li (click)="closeSharedMenu()" class="closeShared">
        <gl-icon [name]="'close'" class="closeSharedMenu"></gl-icon>
      </li>
    </ul>
  }
  @if ((isViewingSharedProject() | async) === true  && !isSharedMenuOpen) {
    <ul class="shared-menu dropdown-menu right">
      <li (click)="openSharedMenu()">
        <gl-icon [name]="'hamburger'" class="menuIcon"></gl-icon>
      </li>
    </ul>
  }
  @if ((isViewingSharedProject() | async) === false) {
    <ul class="dropdown-menu right">
      <li glDropdownClick>
        <gl-icon [name]="'project'"></gl-icon>
        <ul class="dropdown">
          <li (click)="newProject()" [ngClass]="{ disabled: isProjectEmpty() }">
            <span class="icon">
              <gl-icon [name]="'newProject'" class="iconWidth20"></gl-icon>
            </span>
            {{ 'new_project' | translate }}
          </li>
          <li (click)="openProject()" class="iconWidth20">
            <span class="icon">
              <gl-icon [name]="'openProject'"></gl-icon>
            </span>
            {{ 'open_project' | translate }}
          </li>
          <li (click)="saveProject()" [ngClass]="{ disabled: isProjectEmpty() }">
            <span class="icon">
              <gl-icon [name]="'saveProject'"></gl-icon>
            </span>
            {{ 'save_project' | translate }}
          </li>
          <li (click)="importFromCSV()" [ngClass]="{ disabled: !user.isPremium }">
            <span class="icon">
              <gl-icon [name]="'importCsv'"></gl-icon>
            </span>
            {{ 'import_file' | translate }}
          </li>
          <li (click)="exportToCSV()" [ngClass]="{ disabled: !user.isPremium || !isWorkSpace() }">
            <span class="icon">
              <gl-icon [name]="'exportCsv'"></gl-icon>
            </span>
            {{ 'export_to_file' | translate }}
          </li>
        </ul>
      </li>
      <li glDropdownClick (click)="refresh()">
        <gl-icon [name]="'shareIco'"></gl-icon>
        <ul class="dropdown">
          <li (click)="shareProject()" [ngClass]="{ disabled: !isWorkSpace() }">
            <span class="icon"><gl-icon [name]="'shareIco'" class="iconWidth20"></gl-icon></span>
            {{ 'share_project' | translate }}
          </li>
          @if (isEmapa) {
            <li (click)="connectWithEmapa()" [ngClass]="{ disabled: !isWorkSpace() }">
              <span class="icon"><gl-icon [name]="'emapaIco'" class="iconWidth20"></gl-icon></span>
              {{ 'connect_with_eMapa' | translate }}
            </li>
          }
          @if (isTrans) {
            <li (click)="publishToTrans()" [ngClass]="{ disabled: !isWorkSpace() }">
              <span class="icon"><gl-icon [name]="'trans-button'" class="iconWidth30 transIcon"></gl-icon></span>
              {{ 'send_to_trans' | translate }}
            </li>
          }
        </ul>
      </li>
      <li glDropdownClick>
        <gl-icon [name]="'pdfIco'"></gl-icon>
        <ul class="dropdown">
          <li (click)="downloadPdf(false)" [ngClass]="{ disabled: !isWorkSpace() }">
            <span class="icon"><gl-icon [name]="'pdfIco'" class="iconWidth20"></gl-icon></span>
            {{ 'download_pdf' | translate }}
          </li>
          <li (click)="downloadPdf(true)" [ngClass]="{ disabled: !isWorkSpace() }">
            <span class="icon"><gl-icon [name]="'addPhoto'" class="iconWidth23"></gl-icon></span>
            {{ 'download_pdf_screenshot' | translate }}
          </li>
        </ul>
      </li>
      <li glDropdownClick>
        <span class="icon"><gl-icon [name]="'visualSettings'"></gl-icon></span>
        <ul class="dropdown">
          <li (click)="showLoadHints()" [ngClass]="{ off: !isHintsEnabled }">
            <span class="icon"><gl-icon [name]="'addShadows'"></gl-icon></span>
            {{ 'show_load_hints' | translate }}
          </li>
          <li (click)="showLoadName()" [ngClass]="{ off: !isLoadNameEnabled }">
            <span class="icon"><gl-icon [name]="'showNames'" class="iconWidth13"></gl-icon></span>
            {{ 'show_load_name' | translate }}
          </li>
          <li (click)="showPalletContents()" [ngClass]="{ off: !isPalletContentsEnabled }">
            <span class="icon"><gl-icon [name]="'showNames'" class="iconWidth13"></gl-icon></span>
            {{ 'show_pallet_contents' | translate }}
          </li>
          <li (click)="backlightSwitch()" [ngClass]="{ off: !isBacklightEnabled }">
            <span class="icon"
              ><gl-icon [name]="'highlightLoads'" class="iconWidth22"></gl-icon
            ></span>
            {{ 'backlight_switch' | translate }}
          </li>
          <li (click)="addShadows()" [ngClass]="{ off: !isShadowsEnabled }">
            <span class="icon"><gl-icon [name]="'addShadows'" class="iconWidth22"></gl-icon></span>
            {{ 'add_shades' | translate }}
          </li>
          <li (click)="addIlluminationLoadPlaces()" [ngClass]="{ off: !isIlluminationLoadPlacesEnabled }">
            <span class="icon"><gl-icon [name]="'addShadows'" class="iconWidth22"></gl-icon></span>
            {{ 'add_illumination_load_places' | translate }}
          </li>
          <li (click)="measureSwitch()" [ngClass]="{ off: !isMeasureEnabled }">
            <span class="icon"><gl-icon [name]="'showMeasure'" class="iconWidth22"></gl-icon></span>
            {{ 'measure_switch' | translate }}
          </li>
        </ul>
      </li>
      <li glDropdownClick>
        <gl-icon [name]="'loadsSettings'"></gl-icon>
        <ul class="dropdown">
          <li (click)="reset()" [ngClass]="{ off: !isWorkSpace() }">
            <span class="icon">
              <gl-icon [name]="'startArrangement'" class="iconWidth16"></gl-icon>
            </span>
            {{ 'initial_arrangement' | translate }}
          </li>
          <li (click)="switchMagnet()" [ngClass]="{ off: !isMagnetEnabled }">
            <span class="icon">
              <gl-icon [name]="'magnet'" class="iconWidth22"></gl-icon>
            </span>
            {{ 'load_attracting' | translate }}
          </li>
          <li (click)="deleteAll()" [ngClass]="{ off: !isWorkSpace() }">
            <span class="icon">
              <gl-icon [name]="'deleteLoads'" class="iconWidth13"></gl-icon>
            </span>
            {{ 'remove_loads_from_the_project' | translate }}
          </li>
          <li>
            <span class="units">
              <span class="icon">
                <gl-icon [name]="'units'"></gl-icon>
              </span>
              {{ 'units' | translate }}
            </span>
            <gl-radio-button-units (click)="changeUnits($event, 'cm')" [checked]="isCm()"
              >{{ 'units_metric' | translate }}
            </gl-radio-button-units>
            <gl-radio-button-units (click)="changeUnits($event, 'mm')" [checked]="isMm()"
              >{{ 'units_mm' | translate }}
            </gl-radio-button-units>
            <gl-radio-button-units (click)="changeUnits($event, 'lb')" [checked]="!isCm() && !isMm()"
              >{{ 'units_imperial' | translate }}
            </gl-radio-button-units>
          </li>
        </ul>
      </li>
    </ul>
  }
  @if ((isViewingSharedProject() | async) === false) {
    <ul class="dropdown-menu right">
      <li (click)="undo()" [ngClass]="{ disabled: isUndoImpossible() }">
        <gl-icon [name]="'arrowLeft'"></gl-icon>
      </li>
      <li (click)="redo()" [ngClass]="{ disabled: isRedoImpossible() }">
        <gl-icon [name]="'arrowRight'"></gl-icon>
      </li>
    </ul>
  }
</nav>
@if (isShared) {
  <div class="projectVersionsContainer">
    <div class="projectEditContainer">
      <div class="project-name">
        @if (!isToLong(this.currentProjectName, 40)) {
          <span class="label">{{ 'project_name' | translate }}:&nbsp;</span>
        }
        {{ this.currentProjectName }}
      </div>
      <div class="projectVersionNavContainer">
        @if (isUserLoggedIn) {
          <div class="backwardButton">
            <gl-icon [name]="'arrowLeft'" class="backwardButtonIcon" [ngClass]="{'disabled': currentVersion < 2}"
            (click)="backwardVersionButton()"></gl-icon>
          </div>
        }
        <div class="projectInfo">
          <div class="editedInfo">
            @if (!isToLong(currentProjectEditor, 25)) {
              <span class="label">{{ 'edited_by' | translate }}:&nbsp;</span>
            }
            <span class="projectEditor">{{ currentProjectEditor }}</span>
          </div>
          <div class="versionInfo"><span class="label">{{ 'version' | translate }}:&nbsp;</span> <span
          class="version">{{ currentVersion }}
          <ng-container>
            / {{ numberOfVersions }}
          </ng-container>
        </span>
      </div>
    </div>
    @if (isUserLoggedIn) {
      <div class="forwardButton">
        <gl-icon [name]="'arrowRight'" class="forwardButtonIcon"
          [ngClass]="{'disabled': currentVersion >= numberOfVersions}"
        (click)="forwardVersionButton()"></gl-icon>
      </div>
    }
  </div>
</div>
</div>
}
@if (this.projectApiService.currentProjectName && (isViewingSharedProject() | async) === false) {
  <div
    >
    @if (!isMobile && !isShared) {
      <div class="project-name">
        <span class="label">{{ 'project_name' | translate }}:</span>
        <span class="projectName">{{ this.projectApiService.currentProjectName }}</span>
      </div>
    }
  </div>
}
<nav class="menu-right" [ngClass]="{'sharedMenu': (isViewingSharedProject() | async) === true}">
  @if ((isViewingSharedProject() | async) === true) {
    <div
      class="order-view"
      >
      <div class="order-view-container">
        <!--        [disabled]="(currentObserver === undefined || currentObserver === null) && !startedOrdedView"-->
        <button
          icon-button
          (click)="previousOrderGroup()"
          >
          <gl-icon
            class="order-icon previous-icon"
            [class.disabled-icon]="(currentObserver === undefined || currentObserver === null) && !startedOrdedView"
            [name]="'next'"
          ></gl-icon>
        </button>
        @if (!startedOrdedView) {
          <button icon-button (click)="startOrderView()">
            <gl-icon class="order-icon play" [name]="'play'"></gl-icon>
          </button>
        }
        @if (startedOrdedView) {
          <button icon-button (click)="stopOrderView()">
            <gl-icon class="order-icon stop" [name]="'pause'"></gl-icon>
          </button>
        }
        <button
          icon-button
          (click)="nextOrderGroup()"
          >
          <gl-icon
            class="order-icon"
            [name]="'next'"
          ></gl-icon>
        </button>
      </div>
      @if (currentObserver !== undefined && currentGroup) {
        <div class="current-group">
          <div class="colorCircle" [ngStyle]="{'background-color': getColor()}"></div>
          <div class="current-group-name">
            <h3>
              {{ currentGroup.name | translate }}
            </h3>
            <p>
              {{ currentGroup.dimensions.length }}x{{ currentGroup.dimensions.width }}x{{
              currentGroup.dimensions.height | unit: 'length':false
              }}
              | {{ currentGroup.weight | unit: 'weight':false }}
            </p>
          </div>
        </div>
      }
    </div>
  }
  @if (!user.isPremium && (isViewingSharedProject() | async) === false && !isMobile) {
    <div class="proButtonContainer">
      <button type="button" incentive-button class="button"
        (click)="goToPro()">
        {{ 'go_pro' | translate }}
      </button>
    </div>
  }
  @if ((isViewingSharedProject() | async) === false) {
    <ul class="dropdown-menu">
      <li (click)="openNotifications()">
        <div class="notifications">
          <gl-icon [name]="'notifications'"></gl-icon>
          <span class="notification-number">{{ numberOfNotifications }}</span>
        </div>
      </li>
      <li class="userBadgePadding" glDropdownClick>
        <span class="userBadge">{{ userBadge }}</span>
        <ul class="dropdown">
          <li (click)="navigateToAccount('profile')">
            <span class="icon"><gl-icon [name]="'myProfile'"></gl-icon></span>
            {{ 'account_my_profile' | translate }}
          </li>
          @if (user.premiumRole !== 'employee') {
            <li (click)="navigateToAccount('subscription')">
              <span class="icon"><gl-icon [name]="'mySubscription'"></gl-icon></span>
              {{ 'account_my_subscription' | translate }}
            </li>
          }
          <li (click)="navigateToAccount('invoices')">
            <span class="icon"><gl-icon [name]="'myInvoices'"></gl-icon></span>
            {{ 'account_my_invoices' | translate }}
          </li>
          <li (click)="navigateToAccount('loadingspaces')">
            <span class="icon"
              ><gl-icon [name]="'myLoadingSpaces'" class="iconWidth24"></gl-icon
            ></span>
            {{ 'account_my_loadingspaces' | translate }}
          </li>
          <li (click)="navigateToAccount('loads')">
            <span class="icon"><gl-icon [name]="'myLoads'"></gl-icon></span>
            {{ 'account_my_loads' | translate }}
          </li>
          <li (click)="navigateToAccount('projects')">
            <span class="icon"><gl-icon [name]="'myProjects'"></gl-icon></span>
            {{ 'account_my_projects' | translate }}
          </li>
          <li (click)="navigateToAccount('contact')">
            <span class="icon"><gl-icon [name]="'contact'"></gl-icon></span>
            {{ 'contact' | translate }}
          </li>
          <!-- PRICELIST -->
          <!-- <li
          (click)="navigateToAccount('api')"
          *ngIf="
            (user?.hasIntegration === true && !premiumApiClient) ||
            (premiumApiClient && premiumApi?.isRenewable)
          "
          >
          <span class="icon"><gl-icon [name]="'priceListApi'"></gl-icon></span>
          {{ 'price_list_api' | translate }}
        </li> -->
        <li (click)="navigateToAccount('integration')">
          <span class="icon"><gl-icon [name]="'integration'"></gl-icon></span>
          {{ 'integration' | translate }}
        </li>
        <li (click)="logout()" class="logout">
          <span class="icon"><gl-icon [name]="'logout'"></gl-icon></span>
          {{ 'logout' | translate }}
        </li>
      </ul>
    </li>
    <li (click)="launchFullscreen()" [ngClass]="{ off: isFullscreen }">
      <gl-icon [name]="'fullScreen'"></gl-icon>
    </li>
  </ul>
}

</nav>
